import { createSelector } from '@reduxjs/toolkit';

const defaultFilters = {
  searchQuery: '',
  selectedSteps: [],
  selectedVendors: [],
  selectedDepartments: [],
  dateRange: {
    startingDate: null,
    endDate: null,
    formattedDate: {},
  },
};

const selectDoneOrdersData = state => state.doneOrders;

export const selectDoneFilters = companyId =>
  createSelector(
    selectDoneOrdersData,
    state => state.filters.doneOrders[companyId] || defaultFilters
  );
